<template>
  <div class="min-h-screen my-3 ml-0 lg:mr-3 w-full overflow-x-auto relative">
    <transition name="fade">
      <div
        v-if="loading"
        class="inset-0 absolute bg-black rounded-md bg-opacity-40 w-full"
      >
        <loader class="center-h-v" />
      </div>
    </transition> 

    <div class="bg-white mx-3 rounded-b-md h-auto" v-if="routeParam == 'all'">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold w-full">List of Employees</p>
      </div>

      <div class="flex justify-between pl-0 ml-0 p-2 w-full">
        <div class="flex justify-between items-left">
          <el-pagination
            background
            @size-change="handleSizeChange"
            :page-sizes="pageSizes"
            :page-index="pageIndex"
            :page-size="pageSize"
            layout="sizes"
            :total="currentTableData.length"
          ></el-pagination>

          <!-- search -->
          <input
            v-model="searchInput"
            type="search"
            placeholder="Start typing to search..."
            class="bg-gray-200 w-52 py-1 rounded-md"
          />
          <!-- search -->
        </div>

        <div class="hidden md:flex md:visible h-full gap-2 items-end">
          <button
            @click="showAddEmployee = true"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/add.svg" />
            <i class="fi fi-sr-plus-small"></i>
            Add
          </button>
          <button
            @click="showBulkUpload = true"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Import
          </button>
          <button
            @click="exportTemplate"
            class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize"
            style="
              justify-items: center;
              align-items: center;
              justify-content: center;
            "
          >
            <img class="h-5" src="@/assets/icons/export-excel.png" />
            Export
          </button>
        </div>
        <div class="flex md:hidden md:invisible md:h-0">
          <ve-popper trigger="clickToOpen" :value="false" width="200">
            <div class="bg-white p-2 shadow-md popper w-full">
              <button
                @click="showAddEmployee = true"
                class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize w-full mb-1"
                style="
                  justify-items: center;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img class="h-5" src="@/assets/icons/add.svg" />
                <i class="fi fi-sr-plus-small"></i>
                Add
              </button>
              <button
                @click="showBulkUpload = true"
                class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize w-full mb-1"
                style="
                  justify-items: center;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img class="h-5" src="@/assets/icons/export-excel.png" />
                Import
              </button>
              <button
                @click="exportTemplate"
                class="border-1.5 rounded-full px-2 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex gap-1 capitalize w-full mb-1"
                style="
                  justify-items: center;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img class="h-5" src="@/assets/icons/export-excel.png" />
                Export
              </button>
            </div>

            <button slot="reference">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Outline"
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <circle cx="12" cy="2" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="12" cy="22" r="2" />
              </svg>
            </button>
          </ve-popper>
        </div>
      </div>
      <!-- {{ loading }} -->
      <div class="px-2 pb-2">
        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocCrSuccess"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="showLocDelSuccess"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_loca }}
          </div>
        </transition>
        <div v-if="!loading" class="h-full">
          <!-- {{ activeTab }} -->
          <el-tabs
            type="border-card"
            v-model="activeTab"
            style="min-height: 100%"
          >
            <el-tab-pane
              v-for="(tab, index) in tabs"
              :key="index"
              :label="tab.Name"
              :id="tab.employmentStatusId"
              :name="tab.Name.trim().toLowerCase()"
              style="margin: 0 !important; padding: 0 !important"
            >
              <ve-table
                style="min-height: 100%"
                :scroll-width="1400"
                v-if="searchInput"
                :columns="filterColumns"
                :table-data="searchTableData()"
                sort-order="asc"
              />
              <ve-table
                style="min-height: 100%"
                :scroll-width="1400"
                :columns="filterColumns"
                :tableData="filteredTableData"
                v-if="!searchInput.length"
              >
              </ve-table>
              <div
                v-if="
                  !loading &&
                  !searchInput.length &&
                  filteredTableData.length === 0
                "
                class="flex flex-col justify-center items-center h-full mt-5"
              >
                <el-empty :image-size="70" description="No Data"></el-empty>
              </div>
              <p
                v-if="searchInput.length && filteredTableData.length === 0"
                class="text-center py-3"
              >
                No results
              </p>
              <div class="table-pagination text-center mt-2">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalCount"
                  :page-size="pageSize"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <transition name="fade">
        <div
          v-if="get_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ get_error }}
        </div>
      </transition>
    </div>

    <employee v-else :setLoading="setLoading"></employee>

    <AddEmployee
      v-if="showAddEmployee"
      @close="showAddEmployee = false"
      @closeOnSuccess="closeOnSuccess"
      :showAddEmployee="showAddEmployee"
      :refresh="refresh"
    ></AddEmployee>

    <EditEmployeeModal
      :showEditEmployeeModal="showEditEmployeeModal"
      :selectedEmployee="selectedEmployee"
      :refresh="refresh"
      @close="showEditEmployeeModal = false"
    ></EditEmployeeModal>

    <BulkUpload
      v-if="showBulkUpload"
      :close="close"
      :showBulkUpload="showBulkUpload"
      :showBulkUploadCallback="showBulkUploadCallback"
      :title="title"
      dataType="Employees"
      :url="url"
      :dateColumns="['DateOfJoining', 'StartDate', 'EndDate', 'DateOfBirth']"
      :columns="employeeBulkUploadColumns"
    ></BulkUpload>

    <AddEmployeeEditReason
      :showAddReason="showReasonTextBox"
      @close="showReasonTextBox = false"
      :action="currentAction"
      :getReason="getReason"
      :setIsConfirmed="submitReason"
      :refresh="refresh"
    ></AddEmployeeEditReason>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import axios from 'axios';

import Loader from '@/components/loader/loader.vue';
import ActionWarning from '@/utils/actionWarning.vue';
import { mapGetters } from 'vuex';
import { viewSecuredAttachment } from '@/utils/secureAttachmentsViewer';
import { importTemplateGenerator } from '@/utils/importTemplateGenerator';
import moment from 'moment';
import employeeBulkUploadColumns from '@/data/employeeBulkUploadColumns.js';
import AddEmployeeEditReason from '@/components/employees/modals/addEmployeeEditReason.vue';
import decryptData from '@/utils/decrypt';
export default {
  name: 'leaveTypeList',
  components: {
    Loader,
    ActionWarning,
    AddEmployeeEditReason,
    AddEmployee: () => import('@/components/employees/modals/addEmployee.vue'),
    EditEmployeeModal: () => import('@/components/employees/modals/editEmployeeModal.vue'),
    BulkUpload: () => import('@/utils/bulkUploadsUtils.vue'),
    Employee: () => import('@/components/employees/employee.vue'),
  },
  data() {
    return {
      activeTab: '',
      tabs: [],
      empoymentStatuses: [],
      showDeleteConfirmation: false,
      deleteIsConfirmed: false,
      showBulkUpload: false,
      url: `/employee/${this.$ApiVersion}/bulkupload`,
      showAddEmployee: false,
      showEmployeeBulkUpload: false,
      loading: false,
      get_error: null,
      create_success: null,
      del_loca: null,
      del_error: null,
      info: null,
      message: null,
      title: 'Bulk Upload Employees',
      searchInput: '',
      showLocCrSuccess: false,
      showLocDelSuccess: false,
      showActions: false,
      selectedEmployee: null,
      showWarning: false,
      leaveTypeToEdit: {},
      pageIndex: 1,
      pageSize: 10,
      pageSizes: [],
      showReason: false,
      showReasonTextBox: false,
      showEditEmployeeModal: false,

      reason: '',
      currentAction: '',
      actions: ['Delete', 'Edit'],
      eventCustomOption: {
        bodyRowEvents: ({ row }) => {
          return {
            click: (event) => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.viewEmployee(row.Id, row);
              }
            },
            dblclick: () => {
              if (!(event.target instanceof SVGSVGElement)) {
                this.viewEmployee(row.Id, row);
              }
            },
            contextmenu: () => {},
            mouseenter: () => {},
            mouseleave: () => {},
          };
        },
      },
      columns: [
        {
          field: '',
          key: 'fullname',
          title: '#',
          align: 'left',
          fixed: 'left',
          width: '5%',
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) => {
            let decryptedEmployeeName = row.decryptedFullname.split(' ');
            // Check if decryptedEmployeeName is empty
            if (row.EmployeeNo == 'M024') {
              console.log(decryptedEmployeeName);
            }
            if (
              decryptedEmployeeName.length === 0 ||
              decryptedEmployeeName[0] === ''
            ) {
              decryptedEmployeeName = ['...']; // Fill with dots
            } else {
              decryptedEmployeeName = decryptedEmployeeName.filter(
                (i) => i.trim() !== ''
              );
            }
            return (
              <div
                onClick={() => this.viewEmployee(row.Id, row)}
                class='flex gap-1 items-center justify-left overflow-x-hidden text-sm cursor-pointer'
              >
                <div class='h-7 w-7 rounded-full bg-gray-400 flex items-center justify-center'>
                  {row.ProfilePicture ? (
                    <img
                      class='h-full w-full rounded-full'
                      src={row.ProfilePicture}
                      alt={this.getInitials(decryptedEmployeeName.join(' '))} // Join array into a string
                    />
                  ) : this.getInitials(decryptedEmployeeName.join(' '))
                      .length ? (
                    <span class='text-white'>
                      {this.getInitials(decryptedEmployeeName.join(' '))}
                    </span>
                  ) : (
                    <img
                      class='h-full w-full rounded-full'
                      src='@/assets/icons/bell.png'
                      alt={this.getInitials(decryptedEmployeeName.join(' '))} // Join array into a string
                    />
                  )}
                </div>
              </div>
            );
          },
          sampleValue: 'a.makanasi',
        },

        {
          field: 'EmployeeNo',
          key: 'EmployeeNo',
          title: 'Employee No',
          align: 'left',
          fixed: 'left',
          width: '8%',
          ellipsis: {
            showTitle: true,
          },
          sampleValue: 'EMPLOYEE-01',
          renderBodyCell: ({ row }) => row.EmployeeNo,
        },

        {
          field: 'Username',
          key: 'Username',
          title: 'Username',
          headerAlign: 'left',
          align: 'left',
          width: '15%',
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement='top-start'
                title={'Username'}
                width='250'
                trigger='hover'
                content={row.Username}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {row.Username}
                </p>
              </el-popover>
            );
          },
          sampleValue: 'anjette.makanasi@acme.com',
        },

        {
          field: 'Fullname',
          key: 'Fullname',
          title: 'Full Name',
          headerAlign: 'left',
          align: 'left',
          sortable: true,
          width: '15%',
          ellipsis: {
            showTitle: true,
          },
          defaultSort: { prop: 'Fullname', order: 'ascending' },

          renderBodyCell: ({ row }) => {
            let fullName = decryptData(row.Fullname, this.$decryptionKey);
            return (
              <el-popover
                placement='top-start'
                title={'Full Name'}
                width='250'
                trigger='hover'
                content={fullName}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {fullName}
                </p>
              </el-popover>
            );
          },

          sampleValue: 'Anjette Makanasi',
        },

        {
          field: 'Gender',
          key: 'Gender',
          title: 'Gender',
          align: 'center',
          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row }) =>
            row.Gender
              ? decryptData(row.Gender, this.$decryptionKey)[0]
              : '....',
          sampleValue: 'Female',
        },

        {
          field: 'EmployementTypeName',
          key: 'EmployementTypeName',
          title: 'Employment Type Name',
          align: 'left',

          renderBodyCell: ({ row }) => (
            <p style='width: 15vw; font-size: 0.8rem !important;'>
              {row.EmployementType}
            </p>
          ),
          sampleValue: 'Permanent',
        },
        {
          field: 'StartDate',
          key: 'StartDate',
          title: 'Start Date',
          align: 'left',

          renderBodyCell: ({ row }) =>
            row.StartDate ? (
              <p style='width: 15vw; font-size: 0.8rem !important;'>
                {moment(row.StartDate).format('dd/mm/yyy')}
              </p>
            ) : (
              <p style='width: 15vw; font-size: 0.8rem !important;'>
                {Array.from({ length: 15 }).fill('.')}
              </p>
            ),

          sampleValue: moment(new Date()).format('DD/MM/YYYY'),
        },
        {
          field: 'EndDate',
          key: 'EndDate',
          title: 'End Date',
          align: 'left',

          renderBodyCell: ({ row }) =>
            row.EndDate ? (
              <p style='width: 15vw; font-size: 0.8rem !important;'>
                {moment(row.EndDate).format('dd/mm/yyy')}
              </p>
            ) : (
              <p style='width: 15vw; font-size: 0.8rem !important;'>
                {Array.from({ length: 15 }).fill('.')}
              </p>
            ),
          sampleValue: moment(new Date()).format('DD/MM/YYYY'),
        },
        {
          field: 'RoleName',
          key: 'RoleName',
          title: 'RoleName',
          align: 'left',
          sampleValue: 'Employee',
        },

        {
          field: 'WorkEmail',
          key: 'WorkEmail',
          title: 'Work Email',
          align: 'left',
          width: '20%',
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            let workEmail = decryptData(row.WorkEmail, this.$decryptionKey);
            return (
              <el-popover
                placement='top-start'
                title={'Work Email'}
                width='250'
                trigger='hover'
                content={workEmail}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {workEmail ? workEmail : '.............'}
                </p>
              </el-popover>
            );
          },

          sampleValue: 'anjette.makanasi@acme.com',
        },
        {
          field: 'WorkPhoneNumber',
          key: 'WorkPhoneNumber',
          title: 'Work Phone Number',
          align: 'left',

          width: '10%',
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            let workPhone = decryptData(
              row.WorkPhoneNumber,
              this.$decryptionKey
            );
            return (
              <el-popover
                placement='top-start'
                title={'Work Phone'}
                width='250'
                trigger='hover'
                content={workPhone}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {workPhone}
                </p>
              </el-popover>
            );
          },

          sampleValue: '0734567876',
        },
        {
          field: 'JobGrade',
          key: 'JobGrade',
          title: 'Job Grade',
          sortable: true,
          headerAlign: 'left',
          align: 'left',

          width: '10%',
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement='top-start'
                title={'Job Grade'}
                width='250'
                trigger='hover'
                content={row.JobGrade}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {row.JobGrade}
                </p>
              </el-popover>
            );
          },

          sampleValue: 'Entry Level',
        },
        {
          field: 'JobGradeName',
          key: 'JobGradeName',
          title: 'Job Grade Name',
          sortable: true,
          headerAlign: 'left',
          ellipsis: {
            showTitle: true,
          },
          align: 'left',

          renderBodyCell: ({ row }) => {
            return (
              // active
              <p class=''>{row.JobGradeName}</p>
            );
          },
          sampleValue: 'Entry Level',
        },
        {
          field: 'DateOfJoining',
          key: 'DateOfJoining',
          title: 'Date Of Joining',
          align: 'left',
          width: '10%',
          ellipsis: {
            showTitle: true,
          },

          renderBodyCell: ({ row }) => {
            return (
              <el-popover
                placement='top-start'
                title={'Date of Joining'}
                width='250'
                trigger='hover'
                content={row.DateOfJoining}
              >
                <p
                  slot='reference'
                  class='cursor-pointer'
                  styel='font-size: 0.68rem !important;'
                >
                  {row.DateOfJoining}
                </p>
              </el-popover>
            );
          },
          sampleValue: moment(new Date()).format('DD/MM/YYYY'),
        },
        {
          field: 'CanSignIn',
          key: 'CanSignIn',
          title: 'Can Sign In',
          align: 'center',
          headerAlign: 'center',
          width: '5%',
          renderBodyCell: ({ row }) => (
            <input
              type='checkbox'
              onChange={(e) => this.updateCanSignIn(e, row)}
              v-model={row.CanSignIn}
            />
          ),
          sampleValue: true,
        },
        {
          field: 'Active',
          key: 'Active',
          title: 'Active',
          align: 'center',
          headerAlign: 'center',
          width: '5%',
          renderBodyCell: ({ row }) => (
            <input
              type='checkbox'
              onChange={(e) => this.toggleActive(e, row)}
              v-model={row.CanSignIn}
            />
          ),
          sampleValue: true,
        },
        {
          field: 'EmployementStatus',
          key: 'status',
          title: 'Status',
          sortable: true,
          fixed: 'right',
          width: '6%',
          renderBodyCell: ({ row }) => {
            //console.log(`${row.EmployeeNo} ${row?.EmployementStatus}`);
            return row?.EmployementStatus?.toLowerCase() === 'active' ? (
              <p class='text-green-500  capitalize'>{row?.EmployementStatus}</p>
            ) : (
              <p class='text-yellow-500  capitalize'>
                {row?.EmployementStatus}
              </p>
            );
          },
          sampleValue: 'ACTIVE',
        },
        {
          field: 'EmploymentStatusName',
          key: 'EmploymentStatusName',
          title: 'EmploymentStatusName',
          sortable: true,
          fixed: 'right',
          width: '10%',
          renderBodyCell: ({ row }) => {
            return row?.EmploymentStatusName?.toLowerCase() === 'active' ? (
              <p class='text-green-500  capitalize'>
                {row?.EmploymentStatusName}
              </p>
            ) : (
              <p class='text-yellow-500  capitalize'>
                {row?.EmploymentStatusName}
              </p>
            );
          },
          sampleValue: 'ACTIVE',
        },
        {
          title: 'Action',
          field: '',
          key: 'action',
          fixed: 'right',
          width: '10%',
          renderBodyCell: ({ row }) => (
            <el-popover placement='bottom' trigger='click'>
              <div class='bg-white'>
                {this.actions.map((action) => {
                  const buttonClass = `w-full text-left py-1 px-2 hover:bg-primary hover:text-white ${
                    this.showReason && this.currentAction === action
                      ? 'bg-primary'
                      : 'bg-gray-100'
                  }`;

                  return (
                    <button
                      class={buttonClass}
                      style='border-radius: 0 !important'
                      key={action}
                      onClick={() => this.showReasonInput(row, action)}
                    >
                      {action.charAt(0).toUpperCase() + action.slice(1)}
                    </button>
                  );
                })}
              </div>
              <button slot='reference' class='border-0'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  id='Outline'
                  viewBox='0 0 24 24'
                  width='20'
                  height='20'
                >
                  <circle cx='12' cy='2' r='2' />
                  <circle cx='12' cy='12' r='2' />
                  <circle cx='12' cy='22' r='2' />
                </svg>
              </button>
            </el-popover>
          ),
        },
      ],

      tableData: [],
    };
  },

  computed: {
    ...mapGetters(['getOrganization', 'getToken']),

    routeParam() {
      return this.$route.params.type;
    },

    filteredTableData() {
      const targetStatus = this.activeTab?.trim().toLowerCase() || null;
      const searchInputLower = this.searchInput
        ? this.searchInput.toLowerCase()
        : null;
      const filteredData = this.tableData.filter((employee) => {
        // Filter by EmploymentStatus if activeTab is set
        if (
          targetStatus &&
          employee['EmployementStatus']?.trim().toLowerCase() !== targetStatus
        ) {
          return false;
        }

        // If no search input is provided, return the employee as it matches the activeTab filter
        if (!searchInputLower) {
          return true;
        }

        // Check if any property matches the search input
        for (let key in employee) {
          let value = employee[key];

          // Decrypt Fullname and WorkEmail before checking
          if (key === 'Fullname' || key === 'WorkEmail') {
            value = decryptData(value, this.$decryptionKey);
          }

          // Check if the property contains the search input
          if (value?.toString().toLowerCase().includes(searchInputLower)) {
            return true;
          }
        }

        return false;
      });

      return filteredData;
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      pageIndex, pageSize;
      return this.searchInput ? this.tableData : this.tableData;
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.fetchEmploymentStatus();
    this.employeeBulkUploadColumns = employeeBulkUploadColumns;
    this.getEmployees();
    this.setPageSizes();
    this.filterColumns = [
      ...this.columns.filter(
        (column) =>
          column.field !== 'RoleName' &&
          column.field !== 'JobGradeName' &&
          column.field !== 'EmploymentStatusName' &&
          column.field !== 'EmployementTypeName'
      ),
    ];
  },

  methods: {
    searchTableData() {
      const searchInputLower = this.searchInput.toLowerCase().trim();
      if (!searchInputLower) {
        return this.tableData;
      }

      return this.tableData.filter((employee) => {
        for (let key in employee) {
          let value = employee[key];
          if (key === "Fullname" || key === "WorkEmail") {
            value = decryptData(value, this.$decryptionKey);
          }
          if (value?.toString().toLowerCase().includes(searchInputLower)) {
            return true;
          }
        }
        return false;
      });
    },
    preprocessData(data) {
      return data.map((employee) => {
        return {
          ...employee,
          decryptedFullname: decryptData(
            employee.Fullname,
            this.$decryptionKey
          ),
          decryptedWorkEmail: decryptData(
            employee.WorkEmail,
            this.$decryptionKey
          ),
        };
      });
    },
    isLoading(isLoading) {
      isLoading;
      this.loading = isLoading;
    },
    getInitials(fullname) {
      if (!fullname) return ''; // Handle case where fullname is not provided

      let decryptedEmployeeName = decryptData(fullname, this.$decryptionKey);
      const names = decryptedEmployeeName?.split(' ');

      if (!names) return ''; // Handle case where decryptedEmployeeName is not provided

      let initials = names[0][0].toUpperCase(); // Initial of the first name

      if (names.length > 1) {
        if (names[1].length > 1) {
          // Check if the second name has more than one character
          initials += names[1][0].toUpperCase(); // Append the initial of the second name
        } else if (names.length > 2) {
          // If the second name is one character, check if there are more names
          initials += names[2][0].toUpperCase(); // Append the initial of the third name
        }
      }

      return initials;
    },
    refresh() {
      this.getEmployees();
      this.showAddEmployee = false;
    },
    setLoading(isLoading) {
      this.loading = isLoading ? true : false;
    },
    handleCancel() {
      this.showDeleteConfirmation = false;
      this.showReason = false;
      this.showReasonTextBox = false;
    },
    getReason(reason) {
      this.reason = reason;
    },
    showBulkUploadCallback() {
      this.showBulkUpload = false;
      this.getEmployees();
    },
    close() {
      this.showBulkUpload = false;
    },
    showReasonInput(row, action) {
      this.selectedEmployee = row;
      this.currentAction = action;

      if (action === 'Edit') {
        this.showEditEmployeeModal = true;
        return;
      }

      this.showReason = true;
      this.showReasonTextBox = this.showReason;
      if (this.showReason) {
        this.reason = '';
      } else {
        this.currentAction = '';
      }
    },

    submitReason() {
      this.showReasonTextBox = false;
      this.reason = '';
      this.currentAction = '';

      this.showWarning = true;

      this.message = 'This action is permanent. Do you want to proceed?';

      this.title = 'Delete Employee';
    },
    activateEmployee(employee) {
      employee;
      this.loading = true;
      this.showReasonTextBox = false;

      setTimeout(() => {
        this.loading = false;

        this.$notify.error({
          title: 'Failure',
          message: 'You cannot activate the employee at this time',
        });
      }, 2500);
    },
    deactivateEmployee(employee) {
      employee;
      this.loading = true;
      this.showReasonTextBox = false;
      setTimeout(() => {
        this.loading = false;
        this.$notify.error({
          title: 'Failure',
          message: 'You cannot deactivate the employee at this time',
        });
      }, 2500);
    },
    suspendEmployee(employee) {
      employee;
      this.loading = true;
      this.showReasonTextBox = false;
      setTimeout(() => {
        this.loading = false;

        this.$notify({
          title: 'Failure',
          message: 'You cannot suspend employee at this time',
        });
      }, 2500);
    },
    updateCanSignIn(e, row) {
      const data = {
        EmployeeId: row.Id,
        CanSignIn: false,
      };

      if (e.target.checked) {
        data.CanSignIn = true;
      }

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/${this.$ApiVersion}/cansign`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            console.log(response.data)
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
    // /{organization}/setup/employment/status/v1/create
    fetchEmploymentStatus() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/employment/status/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tabs = response.data.Data?.sort((a, b) =>
                a.Name.trim().localeCompare(b.Name.trim())
              );
              this.activeTab = this.tabs[0]?.Name.trim().toLowerCase();
              this.empoymentStatuses = response.data.Data.map((status) =>
                status.Name.trim().toLowerCase()
              );
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
    toggleActive(e, row) {
      const data = {
        EmployeeId: row.Id,
        Status: "Inactive",
      };

      if (e.target.checked) {
        data.Status = "Active";
      }

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      axios
        .put(
          `${this.getOrganization}/employee/status/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
    viewEmployee(employeeId, row) {
      // alert(employeeId);
      // Save the employeeId to localStorage
      localStorage.setItem('selectedEmployeeId', employeeId);

      this.$store.commit('setCurrentEmployeeId', employeeId);
      this.$store.commit('setUserToView', row);
      this.$router.push({
        name: 'employees',
        params: { type: 'emp-id', company: this.getOrganization },
      });
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },

    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },

    handleCloseOnSuccess() {
      this.showAddEmployee = false;
      this.showLocCrSuccess = false;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getEmployees();
    },

    reload() {
      this.getEmployees()
    },
    setIsConfirmed(type) {
      switch (type) {
        case 'DELETE':
          this.showDeleteConfirmation = false;
          this.showReason = false;
          this.showReasonTextBox = false;
          this.showWarning = false;
          this.deleteEmployee(this.selectedEmployee);
          break;
        case 'SUSPEND':
          this.suspendEmployee(this.selectedEmployee);
          break;

        case 'DEACTIVATE':
          this.deactivateEmployee(this.selectedEmployee);
          break;
        case 'ACTIVATE':
          this.activateEmployee(this.selectedEmployee);
          break;
        default:
          break;
      }
      // this.showWarning = false;
    },

    handleDeleteButtonClick(employee) {
      this.title = `Delete ${employee.Fullname}`;
      this.message = `You are about to delete ${employee.Fullname}!`;
      this.selectedEmployee = employee;
      this.showWarning = true;
    },

    handleDeleteOnSuccess() {
      this.showLocDelSuccess = true;
      setTimeout(() => {
        this.showLocDelSuccess = false;
      }, 3000);
      this.getEmployees();
    },

    async getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        const response = await axios.get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        );

        if (response.data.StatusCode == 200) {
          const employees = this.preprocessData(response.data.Data);
          // Update the ProfilePicture for each employee
          await Promise.all(
            employees.map(async (employee) => {
              employee.ProfilePicture = await viewSecuredAttachment(
                employee.ProfilePicture,
                this.getToken
              );
            })
          );

          // Find the index of the employee with the specified ID
          // const indexToUpdate = employees.findIndex(
          //   (emp) => emp.Id === "1957372d-d02b-4fe3-94cd-8342a5b7a24f"
          // );

          // // Update the Fullname for the employee if found
          // if (indexToUpdate !== -1) {
          //   // Assuming `decryptedEmployeeName` is the updated Fullname
          //   employees[indexToUpdate].Fullname = "James Njogu";
          // }

          this.$store.commit('setEmployees', employees);
          this.tableData = employees;
          this.loading = false;
        } else {
          this.get_error = response.data.StatusMessage;
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },

    async deleteEmployee(row) {
      this.showDeleteConfirmation = false;
      this.showReason = false;
      this.showReasonTextBox = false;
      this.loading = true;

      try {
        const response = await axios.delete(
          `${this.getOrganization}/employee/v1/delete`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
            },
            data: {
              EmployeeId: row.Id,
            },
          }
        );

        this.loading = false;
        if (response.data.StatusCode == 200) {
          this.$notify({
            title: 'Success',
            message: response.data.StatusMessage,
            type: 'success',
          });
          this.getEmployees();
        } else {
          this.$notify.error({
            title: 'Failure',
            message: response.data.StatusMessage,
          });
        }
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: 'Failure',
          message: error.message,
        });
      }
    },

    editLeaveType(row) {
      this.showEditLeaveType = true;
      this.info = row;
    },

    exportTemplate() {
      let columns = this.columns.filter(
        (c) =>
          c.field !== 'Role' &&
          c.field !== 'EmployementType' &&
          c.field !== 'EmploymentStatus' &&
          c.field !== 'JobGrade' &&
          c.title !== 'Action' &&
          c.field !== 'Status' &&
          c.field !== 'Active' &&
          // c.field !== "CanSignIn" &&
          c.field !== 'EmployementStatus' &&
          c.field !== 'StartDate' &&
          c.field !== 'EndDate' &&
          c.field !== 'EmployementTypeName' && //0723967842
          c.title !== '#'
      );
      const newColumns = [
        {
          field: 'JobTitle',
          key: 'JobTitle',
          title: 'Job Title',
          align: 'left',
          width: '10%',
          sampleValue: 'Sales Engineer',
        },
        {
          field: 'LeaveWorkflow',
          key: 'LeaveWorkflow',
          title: 'Leave Workflow',
          align: 'left',
          width: '10%',
          sampleValue: 'Test Workflow',
        },
        {
          field: 'ClaimWorkflow',
          key: 'ClaimWorkflow',
          title: 'Claim Workflow',
          align: 'left',
          width: '10%',
          sampleValue: 'All claims',
        },
        {
          field: 'PayrollNumber',
          key: 'PayrollNumber',
          title: 'Payroll Number',
          align: 'left',
          width: '10%',
          sampleValue: 'PR-0045',
        },
        {
          field: 'DateOfBirth',
          key: 'DateOfBirth',
          title: 'Date Of Birth',
          align: 'left',
          width: '10%',
          sampleValue: moment(new Date()).format('DD/MM/YYYY'),
        },
        {
          field: 'HomeEmail',
          key: 'HomeEmail',
          title: 'Home Email',
          align: 'left',
          width: '10%',
          sampleValue: 'homeemail@yahoo.com',
        },
        {
          field: 'ContactNumber',
          key: 'ContactNumber',
          title: 'Contact Number',
          align: 'left',
          width: '10%',
          sampleValue: '0798765457',
        },
        {
          field: 'IDNumber',
          key: 'IDNumber',
          title: 'ID Number',
          align: 'left',
          width: '10%',
          sampleValue: '34881889',
        },
        {
          field: 'KRAPINNumber',
          key: 'KRAPINNumber',
          title: 'KRA PIN Number',
          align: 'left',
          width: '10%',
          sampleValue: 'AR09878900OR',
        },
        {
          field: 'NHIFNumber',
          key: 'NHIFNumber',
          title: 'NHIF Number',
          align: 'left',
          width: '10%',
          sampleValue: '3456789TE',
        },
        {
          field: 'NSSFNumber',
          key: 'NSSFNumber',
          title: 'NSSF Number',
          align: 'left',
          width: '10%',
          sampleValue: 'ERTYUI688',
        },
        {
          field: 'AccountName',
          key: 'AccountName',
          title: 'Account Name',
          align: 'left',
          width: '10%',
          sampleValue: 'Anjette',
        },
        {
          field: 'BankName',
          key: 'BankName',
          title: 'Bank Name',
          align: 'left',
          width: '10%',
          sampleValue: 'Equity',
        },
        {
          field: 'BankCode',
          key: 'BankCode',
          title: 'Bank Code',
          align: 'left',
          width: '10%',
          sampleValue: 'E-00001',
        },
        {
          field: 'BankAccountNumber',
          key: 'BankAccountNumber',
          title: 'Bank Account Number',
          align: 'left',
          width: '10%',
          sampleValue: '45634789345',
        },
        {
          field: 'BranchName',
          key: 'BranchName',
          title: 'Branch Name',
          align: 'left',
          width: '10%',
          sampleValue: 'Jamhuri',
        },
        // SWIFTCode
        {
          field: 'SWIFTCode',
          key: 'SWIFTCode',
          title: 'SWIFT Code',
          align: 'left',
          width: '10%',
          sampleValue: 'SWIFT-0001',
        },
        {
          field: 'BranchCode',
          key: 'BranchCode',
          title: 'Branch Code',
          align: 'left',
          width: '10%',
          sampleValue: 'J-0001',
        },
      ];
      columns = [...columns, ...newColumns];
      // console.log(columns)
      importTemplateGenerator(
        columns,
        'Employees',
        [
          {
            name: 'EmployeeDepartments',
            headers: [
              'EmployeeNo',
              'Company',
              'Branch',
              'Department',
              'JobTitle',
            ],
            data: [
              ['EMPLOYEE-01', 'DataposIT', 'HQ', 'Business Apps', 'PMO'],
              ['EMPLOYEE-02', 'Ace', 'HQ', 'Infrastructure', 'Web Developer'],
            ],
          },
          {
            name: 'EmployeeContracts',
            headers: [
              'EmployeeNo',
              'EmploymentType',
              'JobTitle',
              'StartDate',
              'EndDate',
            ],
            data: [
              [
                'EMPLOYEE-01',
                'Contract',
                'IT Manager',
                moment(new Date()).format('DD/MM/YYYY'),
                moment(new Date()).format('DD/MM/YYYY'),
              ],
              [
                'EMPLOYEE-02',
                'Permanent',
                'IT Manager',
                moment(new Date()).format('DD/MM/YYYY'),
                moment(new Date()).format('DD/MM/YYYY'),
              ],
            ],
          },
          {
            name: 'EmployeeBenefits',
            headers: ['EmployeeNo', 'BenefitGroup'],
            data: [
              ['EMPLOYEE-01', 'Standard'],
              ['EMPLOYEE-02', 'Basic'],
            ],
          },
          // Add more dimensions as needed
        ],
        false,
        false
      );
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}

.el-input.el-input--mini.el-input--suffix .el-input__inner {
  height: 30px !important;
  background-color: #fff !important;
  border-radius: 0 !important;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0 !important;
}

.el-tabs--border-card > .el-tabs__content {
  padding: 0 !important;
}
</style>
